import { Injectable } from '@angular/core';

export type logType = (msg: string, ...params: any[]) => void;

export interface ILogger {
  info(msg: string, ...params: any[]);

  warn(msg: string, ...params: any[]);

  error(msg: string, ...params: any[]);

  debug(msg: string, ...params: any[]);
}

@Injectable()
export class LoggerService implements ILogger {
  info: any;
  warn: any;
  error: any;
  debug: any;
}
